module.exports = __webpack_public_path__ + "static/img/fuxi-details.ce742ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fuxi-details.png
// module id = KxS8
// module chunks = 0